<template>
    <v-container class="fill-height" style="display: block; padding: 0;" fluid>

        <div class="contacts-list" :class="`small-screen-${smallScreen}`">
            <div>
                <div class="close-button-container" @click="$emit('close')">
                    <span>close <v-icon>mdi-comment-arrow-right</v-icon></span>
                </div>
                <v-divider :key="`divider-close`"></v-divider>
                <v-list-item :key="'broadcast'" @click="contactClick('broadcast')" :style="{paddingTop: '5px', paddingBottom: '5px'}" :class="{selected: (selectedContact == 'broadcast')}" :disabled="!broadcastPermission">
                    <v-list-item-avatar>
                        <v-icon x-large color="#FB8C00">mdi-message-alert</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title v-text="'Broadcast'"></v-list-item-title>
                        <v-list-item-subtitle v-html="'Message all active users'"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </div>


            <v-divider :key="`divider-broadcast`"></v-divider>

            <div class="search-container">
                <v-text-field class="v-search-input" v-model="searchText" placeholder="Search..." solo clearable light background-color="#eeeeee"></v-text-field>
            </div>
            <v-divider :key="`divider-search`"></v-divider>

            <v-list three-line :style="{padding: 0}">
                <template v-for="(contact, index) in filteredContacts">
                    <v-list-item :key="contact.user_id" @click="contactClick(contact)" :disabled="!contact.connected && false" :class="{selected: (selectedContact && selectedContact.user_id == contact.user_id), disabled: !contact.connected}">
                        <v-list-item-avatar>
                            <img :src="contact.userImage" v-if="contact.userImage" />
                            <v-icon x-large v-if="!contact.userImage">fa fa-user-circle</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title v-text="contact.user_username"></v-list-item-title>
                            <v-list-item-subtitle v-html="contact.user_fullname"></v-list-item-subtitle>
                            <div class="client-instances" v-if="contact.sid.length > 1">
                                <span v-text="contact.sid.length"></span>
                            </div>
                            <div class="unread-messages" v-if="contact.unreadMessages">
                                <v-icon class="icon" large>mdi-message</v-icon>
                                <span class="text" v-text="contact.unreadMessages"></span>
                            </div>

                            <div class="webrtc-controls-activator" v-if="contact.connected && !contact.webRtcTray" @click="contact.webRtcTray = true">
                                <v-icon class="icon">mdi-dots-horizontal</v-icon>
                            </div>
                            <div class="webrtc-controls-container" v-if="contact.connected && contact.webRtcTray">
                                <div class="webrtc-control">
                                    <v-btn icon small class="" @click="contact.webRtcTray = false"><v-icon>mdi-close</v-icon></v-btn>
                                </div>
                                <div class="webrtc-control">
                                    <v-btn icon small class="" @click.stop="contactVideoCallClick(contact)"><v-icon>mdi-video</v-icon></v-btn>
                                </div>
                                <div class="webrtc-control">
                                    <v-btn icon small class="" disabled><v-icon>mdi-phone</v-icon></v-btn>
                                </div>
                            </div>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </div>


        <div class="content-wrapper" :class="`small-screen-${smallScreen}`">
            <v-tabs grow dark color="#ffffff" v-model="activeTab">
                <v-btn id="back-to-contacts" icon @click="smallScreen = 'contacts'">
                    <v-icon>mdi-arrow-left-circle</v-icon>
                </v-btn>
                    

                <v-tab key="message">
                    <v-icon>mdi-wechat</v-icon>
                </v-tab>
                <v-tab key="activeUsers">
                    <v-icon>mdi-account-group</v-icon>
                </v-tab>
                <v-tab-item key="message">
                    <div class="meesage-area-wrapper">

                        <div class="message-area" id="ma">
                            <template v-if="selectedContact != 'broadcast'">
                                <div class="message-container" v-for="message in messageView" :key="message.timestamp" :class="{own: message.own, other: !message.own}">
                                    <div class="message-items-container">
                                        <div class="text-container">
                                            <div class="text-container-corner" />
                                            <span class="message-text" v-text="message.text" />
                                        </div>
                                        <div class="avatar-container">
                                            <img :src="selectedContact.userImage" v-if="selectedContact.userImage" />
                                            <v-icon x-large v-if="!selectedContact.userImage">fa fa-user-circle</v-icon>
                                        </div>
                                        <span class="timestamp-text" v-text="message.timestampText" />
                                    </div>
                                </div>
                            </template>
                            <template v-if="selectedContact == 'broadcast'">
                                <div class="historical-broadcast-message-container" v-for="(broadcastMessage, index) in $store.state.broadcastMessage.messageHistory" :key="index">
                                    <span v-text="broadcastMessage.message" />
                                    <v-divider color="#000000" />
                                    <span class="timestamp-text" v-text="`${broadcastMessage.sender} on ${broadcastMessage.timestamp}`" />
                                </div>
                            </template>
                        </div>

                        <div class="compose-container" :class="{disabled: (!selectedContact || !selectedContact.connected) && selectedContact != 'broadcast'}">
                            <textarea v-model="compose" class="textarea" :disabled="(!selectedContact || !selectedContact.connected) && selectedContact != 'broadcast'" :placeholder="composePlaceholder"
                                @keypress.shift.enter.stop="" @keypress.enter.prevent="sendMessage">
                            </textarea>
                            <div class="send-icon">
                                <v-icon x-large :class="{disabled: (!compose || !compose.trim())}" @click="sendMessage">mdi-send</v-icon>
                            </div>
                        </div>

                    </div>
                </v-tab-item>


                <v-tab-item key="activeUsers">
                    <div class="active-users-wrapper">
                        <template v-for="user in activeUsersGrouped">
                            <div :key="user.user_id" class="active-user-container">
                                <div class="user-info">
                                    <span v-text="`${user.user_username}`"></span>
                                    <v-divider class="ml-2 mr-2" color="#575757" :style="{height: '20px'}" vertical />
                                    <span v-text="`${user.user_fullname}`"></span>
                                </div>
                                <v-divider color="#ffffff" />

                                <div class="info-container">
                                    <template v-for="(device, index) in user.activeDevices">
                                        <div class="device-info" :key="device.sid">
                                            <div class="device-type">
                                                <v-icon class="mr-2" v-if="device.sid != $socket.id">{{getDeiceIcon(device.client_device)}}</v-icon>
                                                <span v-if="device.sid == $socket.id">ME</span>
                                            </div>
                                            <div class="device-text">
                                                <span>
                                                    <span v-text="device.client_ip" />
                                                    •
                                                    <span v-text="device.client_device.device_brand_name" />{{' '}}
                                                    <span v-text="device.client_device.os_name" />{{' '}}
                                                    <span v-text="device.client_device.device_type.charAt(0).toUpperCase() + device.client_device.device_type.slice(1)" />
                                                    •
                                                    <v-icon class="mr-1" v-if="device.client_device.client_type.toLowerCase() == 'browser'">{{getBroserIcon(device.client_device.client_name)}}</v-icon>
                                                    <span>{{ `${device.client_device.client_name}(${device.client_device.client_version})` }}</span>
                                                    •
                                                    <v-icon class="mr-1">mdi-monitor-screenshot</v-icon>
                                                    <span>{{ `(${device.screen_resolution})` }}</span>
                                                    <br>
                                                    <span>{{`Connected on: ${formatConnTime(device.connected_time)}`}}</span>
                                                </span>
                                            </div>
                                            <v-btn class="kickoff-button" large text icon @click="kickoffDeviceClick(device)" v-if="(($store.state.user.user_data.is_customer_admin) && (device.sid != $socket.id))">
                                                <v-icon>mdi-logout</v-icon>
                                            </v-btn>
                                        </div>
                                        <v-divider class="mb-2" :key="index" v-if="index != (user.activeDevices.length - 1)" />
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </v-tab-item>
            </v-tabs>
        </div>

    </v-container>
</template>

<script>
export default {
    name: 'Messaging',
    props: [],
    components: {

    },
    data: () => ({
        compose: '',
        searchText: '',
        selectedContact: null,
        composePlaceholder: 'Select a contact to message...',
        activeTab: 0,
        broadcastPermission: false,
        smallScreen: 'contacts'
    }),

    computed: {
        contacts: function() {
            let users = this.$store.state.batchConfig.users;
            let contacts = JSON.parse(JSON.stringify(users));
            let activeClients = this.$store.state.socket.activeClients;
            let mySocketClientId = this.$socket.id;

            // Remove the user we're logged in as
            let currentUserId = this.$store.state.user.user_id;
            contacts = contacts.filter(c => {
                return c.user_id != currentUserId;
            });

            contacts.forEach(contact => {
                contact.connected = false;
                contact.webRtcTray = false;
                contact.sid = [];
            });
            console.log('contacts', contacts)
            for(let activeClient of activeClients) {
                for(let contact of contacts) {
                    if(activeClient.user_id == contact.user_id) {
                        contact.connected = true;
                        contact.sid.push(activeClient.sid);
                    }
                }
            }

            // Calculate list of unread messages
            let contactMessages = this.$store.state.contactMessages;
            for(let contact of contacts) {
                contact.unreadMessages = 0;
                for(let cm of contactMessages) {
                    if(contact.user_id == cm.userId) {
                        for(let m of cm.messages) {
                            if(m.unread) {
                                contact.unreadMessages++;
                            }
                        }
                        break;
                    }
                }
            }

            // Alpha sort the contacts list
            contacts.sort((a, b) => {
                if(!a.connected && b.connected) { return 1; }
                if(a.connected && !b.connected) { return -1; }

                if(a.user_username < b.user_username) { return -1; }
                if(a.user_username > b.user_username) { return 1; }

                return 0;
            });
            
            return contacts;
        },

        filteredContacts: function() {
            if(!this.searchText) {
                return this.contacts;
            }
            return this.contacts.filter(contact => {
                return ((contact.user_username.toLowerCase().includes(this.searchText.toLowerCase())) || (contact.user_fullname.toLowerCase().includes(this.searchText.toLowerCase())));
            });
        },

        messageView: function() {            
            let messages = [];
            if(this.selectedContact && this.selectedContact != 'broadcast') {
                let userId = this.selectedContact.user_id;
                for(let cm of this.$store.state.contactMessages) {
                    if(cm.userId == userId) {
                        for(let message of cm.messages) {
                            message.timestampText = this.buildTimestampText(message);
                            message.unread = false;
                        }
                        messages = cm.messages;
                        break;
                    }
                }
            }
            else {
                return [];    
            }
            let ma = document.getElementById('ma');
            if(ma) {
                setTimeout(() => {
                    ma.scrollTop = 99999999999;
                }, 100);
            }
            return messages;
        },

        activeUsersGrouped: function() {
            let users = JSON.parse(JSON.stringify(this.$store.state.batchConfig.users));
            let activeClients = this.$store.state.socket.activeClients;

            users.forEach(user => {
                user.activeDevices = [];
            });

            for(let activeClient of activeClients) {
                for(let user of users) {
                    if(activeClient.user_id == user.user_id) {
                        user.activeDevices.push(activeClient);
                        break;
                    }
                }
            }

            // Remove the users that are not connected.
            users = users.filter(user => {
                return user.activeDevices.length;
            });

            // Sort user connected devices by time of connected.
            users.forEach(user => {
                user.activeDevices.sort((a, b) => {
                    return a - b;
                });
            });

            // Sort users alpha
            users.sort((a, b) => {
                if(a.user_username < b.user_username) { return -1; }
                if(a.user_username > b.user_username) { return 1; }
                return 0;
            });

            return users;
        }

    },

    methods: {
        contactClick: function(contact) {
            this.activeTab = 0;

            // This is used so the store knows NOT to play the new message sound when the user is actively chatting this contact.
            this.$store.commit('setMessagingDrawerActiveContact', contact);

            if(contact == this.selectedContact) {
                return;
            }

            if(contact == 'broadcast') {
                this.selectedContact = 'broadcast';
                this.composePlaceholder = `Send broadcast...`;
            }
            else {
                this.selectedContact = contact;
                this.composePlaceholder = `Message ${contact.user_username}...`;
            }
            this.compose = '';
            this.smallScreen = 'content';
        },

        contactVideoCallClick: function(contact) {
            //alert('call');

            let webRtc = {
                show: true, 
                contact: contact,
                outgoing: true,
                incoming: false,
            };
            this.$socket.emit('webrtc_invite', {type: 'video', to_username: contact.user_username, from_user_id: this.$store.state.user.user_id});
            this.$store.commit('setWebRtc', webRtc);
            this.$emit('close');
        },

        buildTimestampText: function(message) {
            let messageAgeMS = ((Date.now()) - message.timestamp);
            let messageAgeSec = (messageAgeMS / 1000);
            let timeStr = TELSA.moment(message.timestamp).format("h:mm A");
            if(messageAgeSec > 72000) { // If the message was from over 20hrs ago then display the date too.
                timeStr = TELSA.moment(message.timestamp).format("ddd MMM Do, h:mm A");
            }
            else if(messageAgeSec < 600) { // If the message is less than 10min ago then don't show time.
                timeStr = '';
            }

            let senderName = '';
            if(!message.own) {
                senderName = timeStr ? `${message.sender.user_username} • ` : `${message.sender.user_username}`;
            }
            return `${senderName}${timeStr}`;
        },

        sendMessage: function() {
            this.compose = this.compose.trim();
            if(!this.compose) {
                return;
            }

            // If it's a broadcast then we don't use web-sockets. This allows support for the old client.
            if(this.selectedContact == 'broadcast') {
                this.$store.dispatch('sendBroadcast', this.compose);
            }
            else {
                let sender = {
                    user_fullname: this.$store.state.user.user_fullname,
                    user_id: this.$store.state.user.user_id,
                    user_username: this.$store.state.user.user_username
                };
                let message = {
                    text: this.compose,
                    sender: sender,
                    recipient: this.selectedContact
                };
                this.$socket.emit('message', message);
            }
            this.compose = '';
        },

        getDeiceIcon: function(device) {
            if(device.device_type == 'desktop') {
                if(device.os_name.toLowerCase() == 'mac') {
                    return 'mdi-desktop-mac';    
                }
                else {
                    return 'mdi-monitor';
                }   
            }
            else if(device.device_type == 'tablet') {
                if(device.os_name.toLowerCase() == 'android') {
                    return 'mdi-tablet-android';
                }
                else if(device.os_name.toLowerCase() == 'ios') {
                    return 'mdi-tablet-ipad';
                }
                else {
                    return 'mdi-tablet';
                }
            }
            else if(device.device_type == 'smartphone') {
                if(device.os_name.toLowerCase() == 'android') {
                    return 'mdi-cellphone-android';
                }
                else if(device.os_name.toLowerCase() == 'ios') {
                    return 'mdi-cellphone-iphone';
                }
                else {
                    return 'mdi-cellphone';
                }
            }
            return 'mdi-monitor';
        },

        getBroserIcon: function(browser) {
            let browserName = browser.toLowerCase();
            if(browserName.includes('chrome')) {
                return 'mdi-google-chrome';
            }
            else if(browserName.includes('firefox')) {
                return 'mdi-firefox';
            }
            else if(browserName.includes('safari')) {
                return 'mdi-apple-safari';
            }
            else if(browserName.includes('edge')) {
                return 'mdi-edge';
            }
            else if(browserName.includes('explorer')) {
                return 'mdi-internet-explorer';
            }
            else if(browserName.includes('opera')) {
                return 'mdi-opera';
            }
            return '';
        },

        formatConnTime: function(connTime) {
            return `${TELSA.moment(connTime).format('MMM DD HH:mm:ss')} (${TELSA.getLengthOfTimeFriendlyName(connTime)})`;
        },

        kickoffDeviceClick: function(device) {
            console.log('KICKOFF!!!: ', device);
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: `Are you sure you want to forcibly log off user <b>${device.username}</b> on <b>${device.client_ip}</b>?`,
                type: 'warning',
                confirmAction: () => {this.kickoffDevice(device);}
            });
        },

        kickoffDevice: function(device) {
            this.$socket.emit('kickoff', device.sid);
        },
        
    },

    watch: {
        activeTab: {
            handler(newVal, oldVal) {
                if(newVal != 0) {
                    this.selectedContact = null;
                    this.$store.commit('setMessagingDrawerActiveContact', null);
                }
            },
            deep: true
        }
    },

    mounted() {
        this.broadcastPermission = TELSA.checkPermission(this.$store.state.user, 'admin/send-broadcast');
    }




};
</script>

<style scoped>

    .close-button {
        position: absolute;
        top: 15px;
        right: 15px;
    }

    .contacts-list {
        width: 300px;
        border-right: #575757 solid 1px;
        height: 100%;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
        display: inline-block;
        float: left;
        overflow-y: auto;
        position: relative;
        z-index: 1;
    }

    .close-button-container {
        height: 100%;
        cursor: pointer;
        text-align: center;
        text-transform: uppercase;
        height: 45px;
        padding-top: 7px;
        letter-spacing: 3px;
    }
    .close-button-container span {
        display: block;
        font-size: 22px;
    }
    .close-button-container:hover {
        background-color: rgb(85,85,85);
    }

    .search-container {
        height: 49px;
        width: 100%;
        position: relative;
    }

    .search-container .v-search-input {
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.3);
        font-size: 18px;
        border-radius: 0;
        height: 40px;
    }

    .selected {
        background-color: #959595;
    }

    .contacts-list .disabled {
        opacity: 0.5;
    }

    .client-instances {
        width: 18px;
        height: 18px;
        background-color: #c42111;
        color: #ffffff;
        text-align: center;
        display: block;
        position: absolute;

        /* right: 20px; */
        left: 27px;
        bottom: 8px;

        border-radius: 3px;
        padding-top: 2px;
        font-size: 10pt;
        border: 1px solid rgba(255, 255, 255, 0.25);
    }

    .unread-messages {
        position: absolute;
        right: 16px;
        top: 15px;
    }
    .unread-messages .icon {
        color: #ffffff;
    }
    .unread-messages .text {
        color: #424242;
        display: block;
        position: absolute;
        top: 5px;
        left: 13px;
        /* left: calc(50% - 9px); */
        font-size: 12pt;
        font-weight: bold;
    }


    .webrtc-controls-activator {
        position: absolute;
        right: 17px;
        bottom: 15px;
        width: 35px;
        height: 18px;
        border-radius: 10px;
        background-color: #303030;
        border: 1px solid rgba(255, 255, 255, 0.42);
        text-align: center;
        z-index: 10;
        box-shadow: 2px 2px 3px 0px rgba(0,0,0,0.25);
    }
    .webrtc-controls-activator .icon {
        margin-top: -4px;
        color: #ffffff;
        transition: all 0.3s;
    }
    .webrtc-controls-activator:hover .icon {
        color: #c42111;
        transition: all 0.3s;
    }

    .webrtc-controls-container {
        width: 50px;
        height: 100%;
        background-color: #303030;
        cursor: default;
        position: absolute;
        right: 0;
        border-left: rgba(255, 255, 255, 0.12) 1px solid;
        box-shadow: -2px 0px 5px 0px rgba(0,0,0,0.3);
    }
    .webrtc-controls-container .webrtc-control {
        display: block;
        border-bottom: rgba(255, 255, 255, 0.42) 1px solid;
        text-align: center;
        height: calc((100% / 3) - 0px);
    }
    .webrtc-controls-container .webrtc-control:last-of-type {
        border: none;
    }


    .content-wrapper {
        display: inline-block;
        height: 100%;
        width: calc(100% - 300px);
    }

    .content-wrapper .meesage-area-wrapper {
        /* display: inline-block;
        height: 100%;
        width: calc(100% - 300px); */

        /* height: 100%; */

        height: calc(100vh - 48px);
    }

    .meesage-area-wrapper .message-area {
        height: calc(100% - 120px);
        padding: 20px;
        overflow-y: auto;
    }




    .compose-container {
        height: 100px;
        width: 92%;

        /* height: 80px;
        width: calc(92% - 50px); */

        position: relative;
        margin: auto;
        border: #575757 solid 1px;
        border-radius: 5px;
        background-color: #eeeeee;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
        z-index: 1;
    }
    .compose-container.disabled {
        /* opacity: 0.5; */
        background-color: rgba(255, 255, 255, 0.6);
    }

    .compose-container .textarea {
        height: 100%;
        /* width: 100%; */
        width: calc(100% - 60px);
        outline: none;
        color: #000000;
        resize: none;
        padding: 8px;
    }

    .compose-container .send-icon {
        position: absolute;
        right: 20px;
        top: 25px;
        cursor: pointer;
        color: #858585;
    }
    .compose-container .send-icon i {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
        color: #858585;
    }
    .compose-container .send-icon i.disabled {
        color: #959595;
        cursor: initial;
        text-shadow: none;
    }











    .historical-broadcast-message-container {
        width: 100%;
        display: block;
        position: relative;
        margin-bottom: 0.5em;
        padding: 0.5em;
        /* background-color: #cfd8dc; */
        background-color: #FB8C00;
        color: #000000;
        border-radius: 5px;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
        animation: slide-in-bottom 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }
    @keyframes slide-in-bottom {
        0% {
            transform: translateY(1000px);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .historical-broadcast-message-container .info-text {
        font-size: 9pt;
        display: block;
    }




    .message-container {
        width: 100%;
        display: block;
        position: relative;
        margin-bottom: 0.5em;
        /* animation: slide-in-bottom 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both; */
        animation: scale-in-center 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }
    @keyframes slide-in-bottom {
        0% {
            transform: translateY(1000px);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }
    @keyframes scale-in-center {
        0% {
            transform: scale(0);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    .message-items-container {
        /* width: 30%; */
        min-width: 30%;
        max-width: 45%;
        text-align: left;
    }
    .message-container.own .message-items-container {
        margin-left: auto;
        margin-right: 0;
    }
    .message-container.other .message-items-container {
        margin-left: 0;
        margin-right: auto;
    }


    .text-container {
        padding: 0.5em;
        border-radius: 5px;
        position: relative;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
    }
    .message-container.own .text-container {
        background-color: #cfd8dc;
        border-top-right-radius: 0;
        margin-right: auto;
        width: calc(100% - 20px);
    }
    .message-container.other .text-container {
        background-color: #ffffff;
        border-top-left-radius: 0;
        margin-left: auto;
        width: calc(100% - 45px);
    }

    .message-container .text-container-corner {
        height: 0px;
        width: 0px;
        border-top: 0px solid transparent;
        border-bottom: 8px solid transparent;
        position: absolute;
        top: 0px;
    }
    .message-container.own .text-container-corner {
        border-left: 4px solid #cfd8dc;
        right: -4px;
    }
    .message-container.other .text-container-corner {
        border-right: 4px solid #ffffff;
        left: -4px;
    }


    .avatar-container {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        position: absolute;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
    }
    .avatar-container img {
        border-radius: 50%;
        height: 40px;
        width: 40px;
    }
    .message-container.own .avatar-container {
        right: 0;
        top: 0;
        display: none;
    }
    .message-container.other .avatar-container {
        left: 0;
        top: 0;
    }


    .message-text {
        display: block;
        color: #000000;
    }

    .timestamp-text {
        font-size: 9pt;
        display: block;
    }
    .message-container.other .timestamp-text {
        margin-left: auto;
        width: calc(100% - 46px);
    }









    .active-users-wrapper {
        padding: 20px;
        height: calc(100vh - 48px);
        overflow-y: auto;
    }

    .active-user-container {
        /* height: 300px; */
        border: #575757 solid 1px;
        border-radius: 6px;
        /* margin-bottom: 100px; */
        margin-bottom: 40px;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
    }

    .user-info {
        padding-left: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .user-info span {
        font-size: 14pt;
    }

    .info-container {
        padding: 20px 20px 8px 20px;
    }

    .info-container .device-info {
        margin-bottom: 5px;
        position: relative;
    }
    .info-container .device-info:hover {
        font-weight: bold;
    }

    .info-container .device-info .device-type {
        display: inline-block;
        margin-right: 5px;
        vertical-align: top;
        margin-top: calc((30px / 2) / 2);
    }
    .info-container .device-info .device-type i {
        font-size: 30px;
        animation:blinkingIcon 1s step-start infinite;
    }
    @keyframes blinkingIcon{
        0%{}
        50%{color: #4CAF50;}
    }

    .info-container .device-info .device-type span {
        font-size: 22px;
        margin-right: 6.5px;
        display: block;
        color: #4CAF50;
        font-weight: bold;
    }


    .info-container .device-info .device-text {
        display: inline-block;
    }


    .info-container .device-info .kickoff-button {
        position: absolute;
        right: 5px;
        top: 2px;
    }
    .info-container .device-info .kickoff-button:hover i {
        color: #FF5252;
    }




    #back-to-contacts {
        display: none;
    }

    @media(max-width: 600px) {
        .contacts-list.small-screen-contacts {
            width: 100%;
        }
        .contacts-list.small-screen-content {
            display: none;
        }
        .content-wrapper.small-screen-contacts {
            display: none;
        }
        .content-wrapper.small-screen-content {
            width: 100%;
        }

        #back-to-contacts {
            display: block;
            position: relative;
            margin-top: 6px;
        }
    }
    
    
</style>

<style>

    #messaging-drawer .v-tabs-bar {
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
        z-index: 1;
        border-bottom: #575757 solid 1px;
    }

</style>
